module.exports = __webpack_public_path__ + "img/highroller_1248.65b37d9b.png";